import {CURRENT_PAGE,SetPagePathAction,SET_PAGE_PATH} from './types';

export function setCurrentPathPath(currentPage:CURRENT_PAGE,parms?: {[key: string]: any}):SetPagePathAction{
    return {type:SET_PAGE_PATH, currentPage, parms}
}